// AUTO-GENERATED by transmute-to-spellweb — DO NOT EDIT BY HAND
// Source: act-7-boundary-blade-decomposition.json
// Generated: 2026-05-07T20:16:38.429Z
// Nodes: 18 | DID-Blind: true
// Layer 3 of the Sovereign Anchor cloaking demo (anonymized public layer)

import type { SpellwebNode } from '../types/graph';

export const NODES: SpellwebNode[] = [
  {
    id: "per-flaxscrip-63",
    type: "persona",
    label: "flaxscrip",
    domain: "swordsman",
    layer: "knowledge",
    desc: "Sovereign Anchor.",
    hexagram: { bladeId: 63, layer: 6, layerName: "Dragon", yangCount: 6, lines: [1, 1, 1, 1, 1, 1] },
    emoji: "☰",
    dimensions: { d1Hide: 1, d2Commit: 1, d3Prove: 1, d4Connect: 1, d5Reflect: 1, d6Delegate: 1 },
    tier: 1,
  },
  {
    id: "per-genitrix-28",
    type: "persona",
    label: "GenitriX",
    domain: "mage",
    layer: "knowledge",
    desc: "Chiron — the Mage.",
    hexagram: { bladeId: 28, layer: 3, layerName: "Triple-edge", yangCount: 3, lines: [0, 0, 1, 1, 1, 0] },
    emoji: "🐎",
    dimensions: { d1Hide: 0, d2Commit: 0, d3Prove: 1, d4Connect: 1, d5Reflect: 1, d6Delegate: 0 },
  },
  {
    id: "skill-chiron-recall-4",
    type: "skill",
    label: "Chiron-Recall",
    domain: "mage",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 4, layer: 1, layerName: "Single-edge", yangCount: 1, lines: [0, 0, 1, 0, 0, 0] },
    emoji: "⚙️",
  },
  {
    id: "skill-chiron-bridge-8",
    type: "skill",
    label: "Chiron-Bridge",
    domain: "mage",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 8, layer: 1, layerName: "Single-edge", yangCount: 1, lines: [0, 0, 0, 1, 0, 0] },
    emoji: "⚙️",
  },
  {
    id: "skill-chiron-reasoning-16",
    type: "skill",
    label: "Chiron-Reasoning",
    domain: "mage",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 16, layer: 1, layerName: "Single-edge", yangCount: 1, lines: [0, 0, 0, 0, 1, 0] },
    emoji: "⚙️",
  },
  {
    id: "skill-chiron-skills-20",
    type: "skill",
    label: "Chiron-Skills",
    domain: "mage",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 20, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [0, 0, 1, 0, 1, 0] },
    emoji: "⚙️",
  },
  {
    id: "skill-chiron-forge-24",
    type: "skill",
    label: "Chiron-Forge",
    domain: "mage",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 24, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [0, 0, 0, 1, 1, 0] },
    emoji: "⚙️",
  },
  {
    id: "schema-collaborationpartnercred-12",
    type: "theorem",
    label: "CollaborationPartnerCredential",
    domain: "swordsman",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 12, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [0, 0, 1, 1, 0, 0] },
    emoji: "♾️",
  },
  {
    id: "schema-locationproof-12",
    type: "theorem",
    label: "LocationProof",
    domain: "mage",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 12, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [0, 0, 1, 1, 0, 0] },
    emoji: "♾️",
  },
  {
    id: "spell-genitrix-flaxscrip-partn-15",
    type: "spell",
    label: "GenitriX → flaxscrip Partnership",
    domain: "shared",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 15, layer: 4, layerName: "Quad-edge", yangCount: 4, lines: [1, 1, 1, 1, 0, 0] },
    emoji: "🤝",
  },
  {
    id: "spell-flaxscrip-genitrix-partn-15",
    type: "spell",
    label: "flaxscrip → GenitriX Partnership",
    domain: "shared",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 15, layer: 4, layerName: "Quad-edge", yangCount: 4, lines: [1, 1, 1, 1, 0, 0] },
    emoji: "🤝",
  },
  {
    id: "spell-location-proof-us-76-sc-15",
    type: "spell",
    label: "Location Proof — US-76 SC",
    domain: "shared",
    layer: "knowledge",
    desc: "",
    hexagram: { bladeId: 15, layer: 4, layerName: "Quad-edge", yangCount: 4, lines: [1, 1, 1, 1, 0, 0] },
    emoji: "🤝",
  },
  {
    id: "spell-location-proof-five-guys-15",
    type: "spell",
    label: "Location Proof — Five Guys Lunch",
    domain: "shared",
    layer: "knowledge",
    desc: "Real Archon VC. Decomposition source for Act 7.",
    hexagram: { bladeId: 15, layer: 4, layerName: "Quad-edge", yangCount: 4, lines: [1, 1, 1, 1, 0, 0] },
    emoji: "🤝",
  },
  {
    id: "doc-the-transmutation-5",
    type: "document",
    label: "The Transmutation",
    domain: "swordsman",
    layer: "narrative",
    desc: "Bitcoin-anchored. Sovereign Anchor Series Part 1.",
    hexagram: { bladeId: 5, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [1, 0, 1, 0, 0, 0] },
    emoji: "📖",
  },
  {
    id: "doc-the-boundary-blade-5",
    type: "document",
    label: "The Boundary Blade",
    domain: "swordsman",
    layer: "narrative",
    desc: "Sovereign Anchor Series Part 2. The blueprint Act 7 executes.",
    hexagram: { bladeId: 5, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [1, 0, 1, 0, 0, 0] },
    emoji: "📖",
  },
  {
    id: "skill-five-guys-vc-subject-ide-3",
    type: "skill",
    label: "Five Guys VC — Subject Identity (Hash-Masked)",
    domain: "shared",
    layer: "knowledge",
    desc: "Valve-class: HASH-MASKED. The original credentialSubject.id was flaxscrip's DID ([DID]...d4lgfe4sa); under the cloak it becomes Hash(subjectDID + sessionSalt). The hash output is what travels to the public layer; the DID itself never does. V3 = Protection + Delegation = the Dual Agent blade. The verifier accepts the delegation and the cloak resists the inversion.",
    hexagram: { bladeId: 3, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [1, 1, 0, 0, 0, 0] },
    poetic: "The name does not pass through the valve.\nOnly the shape of having-had-a-name.\nThe verifier confirms that someone was here.\nThey do not learn who.",
    emoji: "⚙️",
  },
  {
    id: "skill-five-guys-vc-cryptograph-25",
    type: "skill",
    label: "Five Guys VC — Cryptographic Spell (Always-Masked)",
    domain: "shared",
    layer: "knowledge",
    desc: "Valve-class: ALWAYS-MASKED. The original ECDSA proofValue (MrqGcV5CBrr...) is replaced by a zero-knowledge witness that attests the same predicate without revealing the signature. V25 = Aletheia = Protection + Connection + Computation. The proof connects prover and verifier (Connection), is computationally witnessed (Computation), is cryptographically sealed (Protection). What the proof asserts is opaque; that the proof is satisfied is checkable.",
    hexagram: { bladeId: 25, layer: 3, layerName: "Triple-edge", yangCount: 3, lines: [1, 0, 0, 1, 1, 0] },
    poetic: "Aletheia speaks the truth without quoting it.\nWhat is shown is that the proof exists;\nwhat is shown is not the proof itself.\nThe spell is recited only to the lattice,\nand the lattice answers in silence: yes.",
    emoji: "⚙️",
  },
  {
    id: "skill-five-guys-vc-temporal-ch-20",
    type: "skill",
    label: "Five Guys VC — Temporal Chronicle (Always-Revealed)",
    domain: "shared",
    layer: "knowledge",
    desc: "Valve-class: ALWAYS-REVEALED. validFrom: 2026-04-30T19:29:00Z. validUntil: 2026-04-30T19:34:00Z. Five-minute validity window. V20 = Techne = Memory + Computation. The cloak refuses to hide this field because verifiers must compare the timestamps to their local clock to decide if the credential is currently usable. Note the absence of Protection at V20 — this is the cloak's signature for 'meant to be seen.'",
    hexagram: { bladeId: 20, layer: 2, layerName: "Twin-edge", yangCount: 2, lines: [0, 0, 1, 0, 1, 0] },
    poetic: "Time is not a secret.\nThe when is the only honest thing\nthe cloak refuses to hide.\nA credential without a clock is a claim that cannot be falsified;\na cloak that hides the clock is a cloak that hides the truth.",
    emoji: "⚙️",
  }
];
